import React from "react";
import { Flex, Box } from "rebass/styled-components";
import styled from "styled-components";
import { EClipsViews, TFilterCompProps } from "../../@types";

/*  Our LOCAL component imports */
import { InfiniteScroll } from "./Components/infiniteScroll";
import { Processing } from "./Components/Processing";

/*  Our GLOBAL component imports */
import { MainRail } from "../Wrappers";
import { LoadingSkeleton } from "../Skeloton";

import CardGrid from "../../../components/organisms/clips/cardGrid";
import { Empty } from "../../Views/Profile/Components/empty";
import { ISetClipInactiveProps } from "../Clip/@types";

import { useUser } from "../../Hooks/useUser";

interface IClipsFeedProps extends TFilterCompProps {
  user: {
    username: string;
  } | null;
  allstarUser: string | null;
  loading: boolean;
  hasMoreData: boolean;
  clips: TClip[];
  fromRemix?: boolean;
  mutateReaction: (data: any) => void;
  followUnfollow?: (data: any) => void;
  paginationClips: () => void;
  setFollowModal: ({ displayName, avatar }: any) => void;
  view: EClipsViews;
  isProfile?: boolean;
  setClipInactive?: ({
    id,
    isMontage,
    deleteMobile,
  }: ISetClipInactiveProps) => void;
  processingData?: { montages: number; userFeed: number };
  isOwnProfile?: boolean;
}

export const ClipFeed = ({
  hasMoreData,
  loading,
  paginationClips,
  clips,
  mutateReaction,
  followUnfollow,
  setFollowModal,
  setClipInactive,
  isProfile,
  view,
  game,
  processingData,
  user,
  isOwnProfile,
}: IClipsFeedProps) => {
  const { allstarUser } = useUser();
  const isMontage = view === EClipsViews.Montages;

  const hasProcessing =
    (isMontage && processingData?.montages) ||
    (!isMontage && processingData?.userFeed);

  if (!loading && !hasMoreData && !clips.length && !hasProcessing) {
    return (
      <MainRail pb={[5, 5, 6]}>
        <Empty isProfile={isProfile} user={user} view={view} />
      </MainRail>
    );
  }

  return (
    <MainRail pb={[5, 5, 6]}>
      <InfiniteScroll
        hasMoreData={hasMoreData}
        isLoading={loading}
        onBottomHit={paginationClips}
        loadOnMount={true}
      >
        <Processing processingData={processingData} view={view} />
        <CardGrid
          clips={clips}
          mutateReaction={mutateReaction}
          allstarUser={allstarUser}
          followUnfollow={followUnfollow}
          feed={true}
          isFeed={true}
          setFollowModal={setFollowModal}
          setClipInactive={setClipInactive}
          isProfile={isProfile}
          view={view}
          isMontage={isMontage}
          autoplay={true}
          game={game}
          isOwnProfile={isOwnProfile}
        />
        {loading ? (
          <LoadingWrapper>
            <LoadingSkeleton height={500} style={{ borderRadius: "0px" }} />
            <Box my={3} />
            <Flex alignItems={"flex-start"} justifyContent="space-between">
              {" "}
              <Flex flexDirection={"column"}>
                <LoadingSkeleton
                  height={35}
                  width={300}
                  style={{ borderRadius: "10px" }}
                />
                <Box my={2} />
                <LoadingSkeleton
                  height={20}
                  width={60}
                  style={{ borderRadius: "6px" }}
                />{" "}
              </Flex>{" "}
              <LoadingSkeleton
                height={40}
                width={120}
                style={{ borderRadius: "999px" }}
              />
            </Flex>
            <Box my={3} />
            <Flex alignItems={"center"}>
              {" "}
              <LoadingSkeleton
                height={40}
                width={40}
                style={{ borderRadius: "999px" }}
              />{" "}
              <Box mx={2} />
              <LoadingSkeleton
                height={30}
                width={130}
                style={{ borderRadius: "10px" }}
              />
            </Flex>
          </LoadingWrapper>
        ) : null}
      </InfiniteScroll>
    </MainRail>
  );
};

const LoadingWrapper = styled(Box)`
  padding-bottom: 80px;
`;
